import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { OpsUnitEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class OpsUnitSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    opsUnitCreated$() {
        return this.socketService.receiveMessageObserver(OpsUnitEvents.OPS_UNIT_CREATED);
    }

    opsUnitUpdated$() {
        return this.socketService.receiveMessageObserver(OpsUnitEvents.OPS_UNIT_UPDATED);
    }

    opsUnitDeleted$() {
        return this.socketService.receiveMessageObserver(OpsUnitEvents.OPS_UNIT_DELETED);
    }

    opsUnitDuplicate$() {
        return this.socketService.receiveMessageObserver(OpsUnitEvents.OPS_UNIT_DUPLICATED);
    }
}
